import * as React from 'react';

import { type SupportedLanguage } from 'lib/lexemes/supported-languages';
import { supportedLanguages } from 'lib/supported-languages';
import { GetStaticPropsContext } from 'next';
import { ParsedUrlQuery } from 'querystring';

import AppContainer from 'containers/common/app/app-container';
import { LandingContainer } from 'containers/landing/landing-container';

const defaultLanguage = supportedLanguages[6];

interface Params extends ParsedUrlQuery {
  lang: SupportedLanguage;
}

type IndexPageProps = {
  lang: SupportedLanguage;
};

const IndexPage: React.FC<IndexPageProps> = ({ lang }) => {
  return <AppContainer pageProps={{ lang }} Component={LandingContainer} />;
};

export default IndexPage;

export async function getStaticPaths() {
  const paths = supportedLanguages.map((lang) => {
    return {
      params: {
        lang,
      },
    };
  });

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps(context: GetStaticPropsContext<Params>) {
  if (!context.params) {
    return {
      props: {
        lang: defaultLanguage,
      },
    };
  }
  const { lang } = context.params;

  return {
    props: {
      lang: lang || defaultLanguage,
    },
  };
}
